import { clsx } from 'clsx';
import { Card } from '@/components/raven/Card';
import type { WPImage, MenuItemEntity } from '@/types/entities';

import styles from './styles.module.css';

interface MegaMenuPostsListProps {
	link: MenuItemEntity;
	marginLabel?: boolean;
}

const MENU_POSTS_LIMIT = 3;

export const MegaMenuPostsList = ({
	link,
	marginLabel,
}: MegaMenuPostsListProps) => {
	const postsList = link.children.find(
		(child) => child.menu_item_type === 'postslist',
	);

	if (!postsList || !postsList.children || !postsList.children.length) {
		return null;
	}

	const label = postsList.title;
	const hasLabel = Boolean(label) && !postsList.hide_label;

	return (
		<div
			className={clsx(styles.menuSectionsListItemSubmenuFeatured, {
				[styles.menuSectionsListItemSubmenuFeaturedMargin]:
					marginLabel && !hasLabel,
			})}
		>
			{hasLabel && (
				<p className={styles.menuSectionsListItemSubmenuHeading}>{label}</p>
			)}
			{postsList.children.slice(0, MENU_POSTS_LIMIT).map((child, i) => {
				const key = `${child.ID}-${i}`;

				return (
					<Card
						button={{
							label: 'Read More',
							variation: 'link',
						}}
						image={
							child.featured_image
								? ({
										alt_text: child.title,
										meta: {
											focal_point: {
												x: child.focal_point?.x,
												y: child.focal_point?.y,
											},
										},
										source_url: child.featured_image,
									} as WPImage)
								: null
						}
						key={key}
						link={child.link ?? ''}
						title={child.title}
						titleTag="p"
						variation="list-media-small"
					/>
				);
			})}
		</div>
	);
};
